/*jshint esversion: 6 */

import React, { Component } from "react";
import Routes from "../components/routes";
import { LoginService } from "../services/login.service";
import { Global_var } from "../global/global_var";
import ErrorBoundary from "../components/errorboundary/errorboundary";
import axios from "axios";
import { getRoleID } from "../components/getRoleId";
import FloatingChatWidget from "../components/chatbot/FloatingChatWidget";
import FloatingChatWidgetRCP2 from "../components/rcp_chatbot/FloatingChatWidgetRCP2";

// import IdleTimer from 'react-idle-timer';
// import {
//   BrowserRouter as Router,
//   Switch,
//   Route,
//   Redirect,
//   Link
// } from "react-router-dom";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      credentials: "",
      reasonCode: "",
      reasonText: "",
      loading: "false",
      token: "",
      jtitoken: "",
      timeout: 1000 * 1200 * 1,
      showModal: false,
      userLoggedIn: false,
      isTimedOut: false,
      roleId: getRoleID(),
    };

    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);

    const isEncrypted = (data) => {
      // Check if the data is base64 encoded
      return /^[a-zA-Z0-9+/]+[=]{0,2}$/.test(data);
    };
    if (Global_var.SECURITY_CHANGE === "false") {
      axios.defaults.headers.common["applicationid"] = "11101";
      axios.defaults.headers.common["buid"] = "2";
      axios.defaults.headers.common["subbuid"] = "1";
      axios.defaults.headers.common["environment"] = "dev";
      axios.defaults.headers.common["issuer"] = "finx";
    }
    axios.defaults.headers.common["tokentype"] = "jti";
    axios.defaults.headers.common["Content-Type"] = "application/json";

    // if (localStorage.getItem('login') !== '' && localStorage.getItem('login') !== null) {
    //   axios.defaults.headers.common['userId'] = JSON.parse(localStorage.getItem('login'))["userId"];
    // } else {
    //   axios.defaults.headers.common['userId'] = '9211420';
    // }

    // if (localStorage.getItem('login') !== '' && localStorage.getItem('login') !== null) {

    //   axios.defaults.headers.common['userlogin'] = JSON.parse(localStorage.getItem('login'))["userName"];
    // } else {
    axios.defaults.headers.common["userlogin"] = "pramila@gmail.com";
    // }
    if (Global_var.SECURITY_CHANGE === "true") {
      console.log(
        "Vamsi APP JS jti-token')",
        localStorage.getItem("jti-token")
      );
      console.log(
        "Vamsi APP JS 'jwt-token')",
        localStorage.getItem("jwt-token")
      );

      const jtiToken = localStorage.getItem("jti-token");
      const jwtToken = localStorage.getItem("jwt-token");
      console.log(
        "Vamsi APP JS if ",
        !jtiToken,
        !jwtToken,
        ["", null, undefined, "null", "undefined"].includes(jtiToken),
        ["", null, undefined, "null", "undefined"].includes(jwtToken)
      );

      if (
        ["", null, undefined, "null", "undefined"].includes(jtiToken) ||
        ["", null, undefined, "null", "undefined"].includes(jwtToken)
      ) {
        const currentPath = window.location.pathname;
        const currentPath1 = currentPath?.toLowerCase();
        const params = new URLSearchParams(window.location.search);
        const sessionTimeout = params.get("sessiontimeout");
        const url = window?.location?.href;
        const indexOfQuestionMark = url?.indexOf("?");
        let encryptedValue;
        let anyFieldFound = "";
        if (indexOfQuestionMark !== -1) {
          encryptedValue = url?.substring(indexOfQuestionMark + 1);
          if (encryptedValue) {
            const isDataEncrypted = isEncrypted(encryptedValue);
            const fields = [
              "cli",
              "col",
              "pro",
              "loc",
              "ref",
              "source",
              "medium",
              "term",
              "camp",
              "protype",
              "proId",
              "emailId",
              "unsubscribeFlag",
            ];
            anyFieldFound =
              fields.some((field) => params.has(field)) || isDataEncrypted
                ? "Y"
                : "";
          }
        }

        console.log(
          "Vamsi APP Params",
          sessionTimeout,
          params,
          window.location.pathname,
          currentPath,
          anyFieldFound
        );
        const excludedPaths = [
          "/unsubscribe-page",
          "/register",
          "/login",
          "/collegeregister",
          "/collegelogin",
          "/opsadminregister",
          "/opsadminlogin",
          "/bfsi-hiring",
          "/referrallink",
          "/process-api",
        ];
        const allowedPaths = [
          "/",
          "/collegeregister",
          "/collegelogin",
          "/opsadminregister",
          "/opsadminlogin",
          "/referrallink",
        ];
        const isExcluded =
          excludedPaths.includes(currentPath1) ||
          currentPath1.startsWith("/process-api/");
        if (currentPath1 !== "/") {
          setTimeout(() => {
            if (!isExcluded) {
              console.log("sessiontimeout true App.js");
              localStorage.clear();
              //OLD
              // const searchParams = window.location.search;
              // const params = new URLSearchParams(searchParams);
              // console.log("vkvk--App1",params.toString())
              // if (params.toString()) {
              //   window.location.href = `/?${params.toString()}`;
              // }
              // else{
              //   window.location.href = "/?sessiontimeout=true"
              // }
              //NEW
              if ([5, "5"].includes(this.state?.roleId)) {
                // window.location.href = "/?sessiontimeout=true"
                if (
                  currentPath1 === "/studentdashboard" &&
                  anyFieldFound === "Y"
                ) {
                  const searchParams = window.location.search;
                  const params = new URLSearchParams(searchParams);
                  console.log("vkvk--app1", params.toString());
                  if (params.toString()) {
                    window.location.href = `/?${params.toString()}`;
                  } else {
                    window.location.href = "/?sessiontimeout=true";
                  }
                }
              } else if ([6, "6", 2, "2"].includes(this.state?.roleId)) {
                window.location.href = "/opsAdminLogin";
              } else if ([6766713, "6766713"].includes(this.state?.roleId)) {
                window.location.href = "/collegeLogin";
              } else {
                if (currentPath1 !== "/bfsi-hiring" && anyFieldFound !== "Y") {
                  window.location.href = "/?sessiontimeout=true";
                } else if (
                  currentPath1 === "/studentdashboard" &&
                  anyFieldFound === "Y"
                ) {
                  const searchParams = window.location.search;
                  const params = new URLSearchParams(searchParams);
                  console.log("vkvk--App1", params.toString());
                  if (params.toString()) {
                    window.location.href = `/?${params.toString()}`;
                  } else {
                    window.location.href = "/?sessiontimeout=true";
                  }
                }
              }
              // window.location.href = "/?sessiontimeout=true"
            }
          }, 200);
        } else if (allowedPaths.includes(currentPath1)) {
          LoginService.TokenUser((res) => {
            localStorage.setItem("jwt-token", res.responseObject);
            localStorage.setItem("jti-token", res.responseObject);
          });
        }
      }
    }
    if (
      localStorage.getItem("jti-token") !== "" &&
      localStorage.getItem("jti-token") !== null &&
      localStorage.getItem("jti-token") !== undefined
    ) {
      axios.defaults.headers.common["jtitoken"] =
        localStorage.getItem("jti-token");
    }
    if (
      localStorage.getItem("jwt-token") !== "" &&
      localStorage.getItem("jwt-token") !== null &&
      localStorage.getItem("jwt-token") !== undefined
    ) {
      axios.defaults.headers.common["token"] =
        localStorage.getItem("jwt-token");
    }
  }

  _onAction(e) {
    //console.log('user did something', e)
    this.setState({ isTimedOut: false });
  }

  _onActive(e) {
    //console.log('user is active', e)
    this.setState({ isTimedOut: false });
  }

  _onIdle(e) {
    //console.log('user is idle', e)
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      //alert("redirecting to login");
      //OLD
      // const searchParams = window.location.search;
      // const params = new URLSearchParams(searchParams);
      // console.log("vkvk--App2",params.toString())
      // if (params.toString()) {
      //   window.location.href = `/?${params.toString()}`;
      // }
      // else{
      //   window.location.href = "/?sessiontimeout=true"
      // }
      //NEW
      if ([5, "5"].includes(this.state?.roleId)) {
        window.location.href = "/?sessiontimeout=true";
      } else if ([6, "6", 2, "2"].includes(this.state?.roleId)) {
        window.location.href = "/opsAdminLogin";
      } else if ([6766713, "6766713"].includes(this.state?.roleId)) {
        window.location.href = "/collegeLogin";
      } else {
        window.location.href = "/?sessiontimeout=true";
      }
      // window.location.href = "/?sessiontimeout=true"
    } else {
      this.setState({ showModal: true });
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  render() {
    const loginData = JSON.parse(localStorage.getItem("login") || "{}");
    const partyId = loginData.partyId ? Number(loginData.partyId) : null;
    const allowedPartyIds = String(
      Global_var.ALLOWED_PARTYIDS_FOR_AI_CHAT || ""
    )
      .split(",")
      .map((id) => Number(id.trim()));
    console.log(
      "Global_var : ",
      Global_var.ENV,
      ["5"].includes(localStorage.getItem("roleId"))
    );

    // const { match } = this.props
    return (
      /* <>
              <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                element={document}
                onActive={this.onActive}
                onIdle={this.onIdle}
                onAction={this.onAction}
                debounce ={250}
          caoture = { false }
                timeout={this.state.timeout} /> */

      <ErrorBoundary>
        <React.Fragment>
          <Routes {...this.state} />
          {((Global_var.ENV === "TEST" &&
            ["5"].includes(localStorage.getItem("roleId"))) ||
            (["5"].includes(localStorage.getItem("roleId")) &&
              allowedPartyIds.includes(partyId))) && (
            <>
              <FloatingChatWidget />
              <FloatingChatWidgetRCP2 />
            </>
          )}
        </React.Fragment>
      </ErrorBoundary>

      /* </>  */
    );
  }
}

export default App;
